import { render, staticRenderFns } from "./HeaderYangzhouA.vue?vue&type=template&id=1a36dc17&"
import script from "./HeaderYangzhouA.vue?vue&type=script&lang=js&"
export * from "./HeaderYangzhouA.vue?vue&type=script&lang=js&"
import style0 from "./HeaderYangzhouA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports